export const ConstantMap = Object.freeze({
    STATE_INICIAL: 1,
    STATE_COMPLETE: 2,
    STATE_MEDICAL_VIEW: 3,
    STATE_NO_OFFER: 4,
    STATE_IN_NEGOTIATION: 5,
    STATE_PENDING_PAYMENT: 6,
    STATE_PENDING_COMMISSION: 7,
    STATE_CLOSED: 8,
    CLAIM_TYPE_MATERIAL_DAMAGE: 1, 
    CLAIM_TYPE_INJURIES: 2, 
});

export const DisplacementTypesMap = Object.freeze({
    MOTORCYCLE: 1,
    BIKE: 2,
    CAR: 3, 
    WALKING: 4,
    BUS: 5,
    TRAIN: 6
});